import { IOemFilter, IType } from '@state/brandsImages/types';

export const getQueryTypes = (selectedFilters: any[], themes?: boolean) => {
    let filtersQuery : string = "";
    let getBy:string = themes ? "theme" : "type";

    let typeFilters =  selectedFilters.filter((filter: any) => filter.id===getBy && filter.value!==null);
    if (typeFilters.length>0) {
      let typesValue = '';
      typeFilters.forEach((filter: any, idx:number) => {
        typesValue+=`${filter.value}`
          if (idx < typeFilters.length-1)typesValue+= `,`;
      })
      filtersQuery+= `and udf.searchTypes( c.${themes?'themes':'types'}, '${getBy}', "${typesValue}")`;
      
    }

    getBy = themes ? "subtheme" : "subtype";
    typeFilters =  selectedFilters.filter((filter: any) => filter.id===getBy && filter.value!==null);
    if (typeFilters.length>0) {
      let typesValue = '';
      typeFilters.forEach((filter: any, idx:number) => {
        typesValue+=`${filter.value}`
          if (idx < typeFilters.length-1)typesValue+= `,`;
      })
      filtersQuery+= `and udf.searchTypes( c.${themes?'themes':'types'}, '${getBy}', "${typesValue}")`;
      
    }
      
    return filtersQuery;
}

export const getQueryYearModel = (selectedFilters: any[], id: string) => {
  let filtersQuery : string = "";
  
  let typeFilters =  selectedFilters.filter((filter: any) => filter.id===id && filter.value!==null);
  if (typeFilters.length>0) {
    let typesValue = '';
    typeFilters.forEach((filter: any, idx:number) => {
      typesValue+=`'${filter.value}'`
        if (idx < typeFilters.length-1)typesValue+= `,`;
    })
    filtersQuery+= ` and c.${id} IN(${typesValue})`;
  }
  return filtersQuery;
}

export const getOEMQueryTypes = (selectedFilters: any[], oemFilter: IOemFilter) => {
  let filters : any[] = [];
  let oemFilters =  selectedFilters.filter((filter: any) => filter.id!=="oem");
  oemFilters.forEach((filter: any, idx:number) => {
    let search = oemFilter.types?.find((itemAllow: IType) =>  itemAllow.value===filter.value);
    if (search) filters.push(search);
  });
  return getQueryTypes(filters);
}